module.exports = __webpack_public_path__ + "img/sphy.55805964.svg";